module.exports = __webpack_public_path__ + "static/media/hex.14d05fff.jpeg";